import { clampViewportOffset } from '@/utils/clampViewportOffset';
import type { Canvas } from 'fabric';
import type { TViewportConstraints } from '@/utils/TViewportConstraints';

// Re-clamps the canvas' current translation. zoomToPoint moves the viewport
// without bounding it, so a zoom can land outside panning range; without this
// the next pan corrects the whole excess in one frame and reads as a jump.
function applyViewportOffsetClamp(fabricCanvas: Canvas, constraints: TViewportConstraints): void {
    const [matX, matY, matZ, matW, offsetX, offsetY] = fabricCanvas.viewportTransform;
    const canvasEl = fabricCanvas.getElement();
    const clamped = clampViewportOffset({
        contentHeight: constraints.contentHeight,
        contentWidth: constraints.contentWidth,
        offsetX,
        offsetY,
        viewportHeight: canvasEl.clientHeight || fabricCanvas.height,
        viewportWidth: canvasEl.clientWidth || fabricCanvas.width,
        zoom: fabricCanvas.getZoom(),
    });
    if (clamped.x === offsetX && clamped.y === offsetY) {
        return;
    }
    fabricCanvas.setViewportTransform([matX, matY, matZ, matW, clamped.x, clamped.y]);
}

export { applyViewportOffsetClamp };
